export enum OutdatedEntityKey {
  baseData = 'baseData',
  translations = 'translations',
  permissions = 'permissions',
  settings = 'settings',
}
